import Helper from "./Helper";
import Swiper from "../lib/swiper";

class SliderHandler {
  constructor(config = {}) {
    const {
      outerWrapperSelector,
      sliderContainerSelector,
      sliderPaginationselector,
      sliderPrevSelector,
      sliderNextSelector
    } = config;

    this.outerWrapperSelector = outerWrapperSelector;
    this.sliderContainerSelector =
      sliderContainerSelector || ".swiper-container";
    this.sliderPaginationselector =
      sliderPaginationselector || ".swiper-pagination";
    this.sliderPrevSelector = sliderPrevSelector || ".swiper-button-prev";
    this.sliderNextSelector = sliderNextSelector || ".swiper-button-next";

    this.sliders = document.querySelectorAll(this.outerWrapperSelector);
    this.slidersArray = Array.prototype.slice.call(this.sliders);

    this.swiperInstances = [];

    if (this.sliders) {
      this.initSwipersDesktop();
      this.getSlideHeight();
    
      window.addEventListener("resize", event =>{
        this.getSlideHeight();  
      });
    }
  }

  initSwipersDesktop() {
    this.slidersArray.forEach((slider, index) => {
      const swiperContainer = slider.querySelector(
        this.sliderContainerSelector
      );
      let swiperConfig = {};
      swiperConfig = {
        autoHeight: true,
        speed: 600,
        slidesPerView: 1,
        centeredSlides: false,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          // dynamicBullets: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      };
      const instance = new Swiper(swiperContainer, swiperConfig);
      this.swiperInstances.push(instance);
    });
  }

  getSlideHeight(){
    if(document.querySelector('.ns-magazine-slide__image')){
      let slideHeight = document.querySelector('.ns-magazine-slide__image').clientHeight;
      if(window.screen.width > 767){
        document.querySelector('.swiper-pagination-wrap').style.top = slideHeight - 50 + "px";
      } else {
        document.querySelector('.swiper-pagination-wrap').style.top = slideHeight - 20 + "px";
      }
      document.querySelector('.swiper-button-prev').style.top = slideHeight/2 + "px";
      document.querySelector('.swiper-button-next').style.top = slideHeight/2 + "px";
    }
  }
}

export default SliderHandler;
